import {fromJust} from '@freckle/maybe'
import type {ParserT} from '@freckle/parser'
import {record, string, stringEnum, nullableDefined} from '@freckle/parser'
import type {components} from '@freckle/educator-entities/ts/curricula-api/generated-client'

export type WordStudyQuestionType = components['schemas']['WordStudyQuestion2']['type']

export const WordStudyQuestionTypes = {
  Input: 'input' as WordStudyQuestionType,
  MultipleChoice: 'multiple_choice' as WordStudyQuestionType,
  Sorting: 'sorting' as WordStudyQuestionType,
  all: function (): Array<WordStudyQuestionType> {
    return [
      WordStudyQuestionTypes.Input,
      WordStudyQuestionTypes.MultipleChoice,
      WordStudyQuestionTypes.Sorting
    ]
  },
  parse: function (s: string): WordStudyQuestionType {
    return fromJust(
      WordStudyQuestionTypes.all().find(questionType => s === questionType),
      `Invalid WordStudyQuestionType ${s}`
    )
  }
}

type WordType = 'diagram' | 'text' | 'sound' | 'image-text'

export const WordTypes = {
  Diagram: 'diagram' as WordType,
  Text: 'text' as WordType,
  Sound: 'sound' as WordType,
  ImageAndText: 'image-text' as WordType,
  all: function (): Array<WordType> {
    return [WordTypes.Diagram, WordTypes.Text, WordTypes.Sound, WordTypes.ImageAndText]
  },
  parse: function (s: string): WordType {
    return fromJust(
      WordTypes.all().find(wordType => s === wordType),
      `Invalid WordType ${s}`
    )
  }
}

export type Word = {
  imageUrl: string | null
  name: string
  type: WordType
  wordAudioUrl: string | null
}

export const parseWord: ParserT<Word> = record({
  imageUrl: nullableDefined(string()),
  name: string(),
  type: stringEnum('WordType', WordTypes.parse),
  wordAudioUrl: nullableDefined(string())
})
